export const privacyPolicy = __(
  'Please contact the property management company for more information on its privacy policy. '
)
